import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'
import { showApiErrorToast, showSuccessToast } from '@utils'
import { useLanguage } from '@context'

interface EncounterPlace {
  place: string
  city?: string
  country?: string
  state?: string
  region?: string
}

interface CreateCalendarEventData {
  title: string
  description: string
  startDateTime: string // ISO date string
  endDateTime?: string // ISO date string
  allDay?: boolean
  rrule?: string | null
  location: EncounterPlace
  type: 'private' | 'common' | 'all'
  participantAccountIds: string[]
  hasReminder: boolean
  descriptionAsReminder: boolean
}

const createCalendarEvent = async (data: CreateCalendarEventData): Promise<string> => {
  const { data: responseData } = await api.post<string>('/calendar-event', data)
  return responseData
}

export const useCreateCalendarEvent = () => {
  const queryClient = useQueryClient()
  const { t } = useLanguage()

  return useMutation<string, Error, CreateCalendarEventData>({
    mutationFn: createCalendarEvent,
    onSuccess: async () => {
      showSuccessToast(t('toast.success'), t('toast.eventCreated'))
      await queryClient.invalidateQueries({ queryKey: ['calendar-events'] })
    },
    onError: (error) => {
      showApiErrorToast(t, error)
    },
  })
}

